import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, FlexSpan, H5, Icon } from "../../ui";
import { StyledCard } from "./styled";
export const ParamsCard = ({ icon, label, active, width, onClick }) => {
    return (_jsx(StyledCard, { flat: true, active: active, width: width, onClick: onClick, children: _jsxs(Flex, { column: true, height: "100%", children: [_jsx(FlexSpan, { flexGrow: 1, children: _jsx(Icon, { icon: icon, size: 24 }) }), _jsx(FlexSpan, { children: _jsx(H5, { children: label }) })] }) }));
};
